<template>
  <div class="staking-header">
    <div class="inner">
      <div class="inner__description">
        <h1 class="title">
          <span class="title-inner"
            ><em class="title-em">$SAUNA</em>Cold PooL Staking<img
              src="/assets/sf/image/emoji_mizuburo.png"
              class="title-icon"
          /></span>
        </h1>

        <p class="lead">
          <span class="lead-inner"
            >Stake SAUNA to earn new tokens. <br />Rewards are calculated per
            block.</span
          >
        </p>

        <img
          src="/assets/sf/image/bg_staking.png"
          alt="Staking Background"
          class="inner__description__image"
        />
      </div>

      <div class="staking-header__auto-compound-bounty">
        <div class="staking-header__auto-compound-bounty__card">
          <div class="staking-header__auto-compound-bounty__card__header">
            <div
              class="staking-header__auto-compound-bounty__card__header__title"
            >
              <svg
                viewBox="0 0 70.745 70.745"
                class="
                  staking-header__auto-compound-bounty__card__header__title__icon
                "
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <linearGradient
                  id="a"
                  gradientUnits="objectBoundingBox"
                  x1=".5"
                  x2=".5"
                  y2="1"
                >
                  <stop offset="0" stop-color="#fdaae0" />
                  <stop offset="1" stop-color="#82d7fd" />
                </linearGradient>
                <g
                  fill="url(#a)"
                  stroke="#fff"
                  stroke-width="2"
                  transform="matrix(.98162718 -.190809 .190809 .98162718 0 11.513)"
                >
                  <circle cx="30.17" cy="30.17" r="30.17" stroke="none" />
                  <circle cx="30.17" cy="30.17" fill="none" r="29.17" />
                </g>
                <g
                  fill="#fff"
                  transform="matrix(.5591929 -.82903757 .82903757 .5591929 11.248 42.205)"
                >
                  <path
                    d="m11.369 18.473a.942.942 0 0 0 -.71-1.562h-2.421c-.016-.24-.025-.481-.025-.725a10.936 10.936 0 0 1 18.44-7.961l3.415-3.995a16.187 16.187 0 0 0 -27.1 11.955c0 .242.006.484.017.725h-2.041a.942.942 0 0 0 -.71 1.562l4.6 5.278.966 1.11 3.47-3.98z"
                  />
                  <path
                    d="m29.033 6.386-3.433-3.936-2.135-2.45-3.049 3.5-2.516 2.886a.942.942 0 0 0 .71 1.562h2.419a10.935 10.935 0 0 1 -17.614 7.878l-3.415 3.995a16.189 16.189 0 0 0 21.558-1.2 16.07 16.07 0 0 0 4.723-10.673h2.041a.942.942 0 0 0 .711-1.562z"
                    transform="translate(9.043 9.008)"
                  />
                </g>
              </svg>
              <p
                class="
                  staking-header__auto-compound-bounty__card__header__title__text
                "
              >
                Auto {{ itemData.stakeTokenSymbol }} Bounty
              </p>
            </div>
            <div
              class="
                staking-header__auto-compound-bounty__card__header__question-mark
              "
            >
              <popper
                :trigger="popperTriggerType"
                :options="{ placement: 'bottom-end' }"
              >
                <div class="popper">
                  <div class="popper__description">
                    <p>
                      This bounty is given as a reward for providing a service
                      to other users.
                    </p>
                    <p>
                      Whenever you successfully claim the bounty, you’re also
                      helping out by activating the Auto
                      {{ itemData.stakeTokenSymbol }} Pool’s compounding
                      function for everyone.
                    </p>
                    <p class="font-bolder">
                      Auto-Compound Bounty: {{ itemData.compoundCallFee }}% of
                      all Auto {{ itemData.stakeTokenSymbol }} pool users
                      pending yield.
                    </p>
                  </div>
                </div>
                <svg
                  slot="reference"
                  version="1.1"
                  id="Layer_1"
                  class="
                    staking-header__auto-compound-bounty__card__header__question-mark__icon
                  "
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 512 512"
                  style="enable-background: new 0 0 512 512"
                  xml:space="preserve"
                >
                  <g>
                    <g>
                      <path
                        d="M256,0C114.509,0,0,114.496,0,256c0,141.489,114.496,256,256,256c141.491,0,256-114.496,256-256
			C512,114.509,397.504,0,256,0z M256,476.279c-121.462,0-220.279-98.816-220.279-220.279S134.538,35.721,256,35.721
			c121.463,0,220.279,98.816,220.279,220.279S377.463,476.279,256,476.279z"
                      />
                    </g>
                  </g>
                  <g>
                    <g>
                      <path
                        d="M248.425,323.924c-14.153,0-25.61,11.794-25.61,25.946c0,13.817,11.12,25.948,25.61,25.948
			c14.49,0,25.946-12.131,25.946-25.948C274.371,335.718,262.577,323.924,248.425,323.924z"
                      />
                    </g>
                  </g>
                  <g>
                    <g>
                      <path
                        d="M252.805,127.469c-45.492,0-66.384,26.959-66.384,45.155c0,13.142,11.12,19.208,20.218,19.208
			c18.197,0,10.784-25.948,45.155-25.948c16.848,0,30.328,7.414,30.328,22.915c0,18.196-18.871,28.642-29.991,38.077
			c-9.773,8.423-22.577,22.24-22.577,51.22c0,17.522,4.718,22.577,18.533,22.577c16.511,0,19.881-7.413,19.881-13.817
			c0-17.522,0.337-27.631,18.871-42.121c9.098-7.076,37.74-29.991,37.74-61.666S295.937,127.469,252.805,127.469z"
                      />
                    </g>
                  </g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                </svg>
              </popper>
            </div>
          </div>
          <div class="staking-header__auto-compound-bounty__card__body">
            <div
              class="staking-header__auto-compound-bounty__card__body__earned"
            >
              <p
                class="
                  staking-header__auto-compound-bounty__card__body__earned__type
                "
              >
                {{ itemData.stakeTokenSymbol }} Earned
              </p>
              <p
                class="
                  staking-header__auto-compound-bounty__card__body__earned__tokens
                "
              >
                {{ toFormattedToken(itemData.account.totalClaimableTokens) }}
              </p>
              <p
                class="
                  staking-header__auto-compound-bounty__card__body__earned__usd
                "
              >
                ~{{ toCurrency(itemData.account.totalClaimableUsd) }} USD
              </p>
            </div>
            <div class="staking-header__auto-compound-bounty__card__body__cta">
              <input-button
                :size="'small'"
                :disabled="
                  !$store.state.isLogin ||
                  itemData.account.totalClaimableTokens <= 0
                "
                @click="claim(itemData)"
                >Claim</input-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputButton from "@/components/atoms/InputButton";
import numFormat from "number-format.js";
import Popper from "vue-popperjs";
import "vue-popperjs/dist/vue-popper.css";

export default {
  props: {
    items: {
      type: Array,
    },
  },
  name: "StakingHeader",
  components: {
    InputButton,
    Popper,
  },
  data() {
    return {
      popperTriggerType: "hover",
    };
  },
  computed: {
    itemData() {
      return this.items[0];
    },
    account() {
      return this.$store.state.account;
    },
  },
  methods: {
    toFormattedToken(num) {
      return numFormat("#,##0.00000", num);
    },
    toCurrency(num) {
      return numFormat("#,##0.00", num);
    },
    claim(stakingPool) {
      this.$store.dispatch("harvest/updateStakingPool", stakingPool);
      this.$store.dispatch("openModal", "limited-sauna-staking-harvest-modal");
    },
  },
  mounted() {
    if (window.innerWidth <= 768) {
      this.popperTriggerType = "clickToOpen";
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.staking-header {
  background-color: var(--color_bg_parts);
  overflow: hidden;

  .inner {
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;

    &__description {
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: relative;

      &__image {
        display: none;

        @include media(sp) {
          display: block;
          margin-bottom: 20px;
        }
      }
    }
  }
  @include media(pc) {
    padding: 0 80px;

    .inner {
      width: 1100px;
      height: 350px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
  }
  @include media(sp) {
    padding: 40px 16px;
  }

  &__auto-compound-bounty {
    &__card {
      background: var(--color_bg_parts);
      border-radius: 20px;
      box-shadow: $box-shadow;
      width: 365px;

      @include media(sp) {
        width: 100%;
      }

      &__header {
        border-bottom: 1px solid $color-border;
        margin-bottom: 24px;
        height: 80px;
        padding: 20px 32px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        &__question-mark {
          display: flex;
          flex-direction: row;
          justify-content: flex-end;

          &__icon {
            width: 20px;
            height: 20px;
            vertical-align: middle;
          }
        }

        &__title {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;

          &__icon {
            width: 40px;
            height: 40px;
            margin-right: 5px;
          }

          &__text {
            font-size: 1.8rem;
            font-weight: 800;
            line-height: 1.2;
          }
        }
      }
      &__body {
        margin: auto 40px 24px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 24px;

        &__earned {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          font-size: 1.5rem;
          &__type {
            font-weight: 600;
            color: #86d3fd;
          }
          &__tokens {
            font-weight: 700;
            font-size: 1.7rem;
          }
          &__usd {
            color: $gray1;
            font-size: 1.2rem;
          }
        }
        &__cta {
        }
      }
    }
  }
}
.title {
  font-weight: 800;
  margin-bottom: 24px;

  @include media(pc) {
    font-size: 3.5rem;
  }
  @include media(sp) {
    font-size: 2.2rem;
  }
}
.title-inner {
  display: inline-block;
  background: $gradation-vertical;
  background-clip: text;
  color: transparent;
  line-height: 1.5;
}
.title-em {
  margin-right: 0.2em;

  @include media(pc) {
    font-size: 5.5rem;
  }
  @include media(sp) {
    display: block;
    font-size: 3.1rem;
  }
}
.title-icon {
  vertical-align: middle;

  @include media(pc) {
    width: 55px;
    margin: -0.2em 24px 0 24px;
  }
  @include media(sp) {
    width: 32px;
    margin: -0.2em 16px 0 16px;
  }
}
.lead-inner {
  display: inline-block;
  background: $gradation-vertical;
  background-clip: text;
  color: transparent;
  font-weight: 400;

  @include media(pc) {
    font-size: 2rem;
  }
  @include media(sp) {
    font-size: 1rem;
    margin-bottom: 40px;
  }
}
.popper {
  text-align: left;
  display: inline-block;
  font-size: 1.2rem;
  max-width: 300px;
  background-color: #232429;
  color: $gray2;
  border-color: transparent;
  padding: 10px;
  border-radius: 10px;

  &__title {
    font-weight: 800;
    font-size: 1.2rem;
    margin-bottom: 0.5em;
  }
  &__description {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .font-bolder {
      font-weight: 700;
    }
  }
}
</style>